export interface DataPerMetricId<DataType> {
    [metricId: number]: DataType;
}

interface BehaviourProjectionResult {
    [projectionEvaluationRangeId: number]: {
        projectionResult: number;
    };
}

export enum BehaviourMedal {
    GOLD = 'gold',
    SILVER = 'silver',
    BRONZE = 'bronze',
    NONE = '',
}

export interface BehaviourRank {
    medal?: BehaviourMedal;
    rank: number;
}

export interface SubBehaviourDataPerMetric {
    rankData: BehaviourRank;
    projectionResultPerRangeId: BehaviourProjectionResult;
}

export interface FocusSelectorSubBehaviourModel {
    id: number;
    identifier: string;
    name: string;
    hasActiveCommitment: boolean;
    dataPerMetricId: DataPerMetricId<SubBehaviourDataPerMetric>;
}
